import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldCopyRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-copy',
	path: '/secure/admin/ViewCopyFieldScreen.jspa',
};
